// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Gbkab","card_header":"Card_card_header__AAqLq","title":"Card_title__QAmU2"};